export default "__VITE_ASSET__BQEqbtXN__"